import { Injectable, signal } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class LoadingService {
	readonly #loadingMap: Map<string, boolean> = new Map<string, boolean>();
	isLoading = signal(false);

	setLoading(loading: boolean, url: string): void {
		if (!url) {
			throw new Error("The request URL must be provided to the `LoadingService.setLoading` function");
		}

		if (loading) {
			this.#loadingMap.set(url, loading);
			this.isLoading.set(true);
		} else if (!loading && this.#loadingMap.has(url)) {
			this.#loadingMap.delete(url);
		}

		if (this.#loadingMap.size === 0) this.isLoading.set(false);
	}
}
